import React from "react"
import { Link as GatsbyLink } from "gatsby-link"

const Link = ({ children, to, activeClassName, partiallyActive, ...other }) => {
  return (
    <a href={to} {...other}>
      {children}
    </a>
  )
}

export default Link



// WEBPACK FOOTER //
// ./src/components/Link.js